import { makeStyles } from '@material-ui/core/styles';


export default makeStyles((theme) => ({
    box: {
        marginTop: '160px'
    },
    title: {
        fontFamily: 'Montserrat, cursive, Arial '
    }
}));
